import { SxProps, Theme } from '@mui/material/styles'
import { isEmpty } from 'lodash'

import CowmedChip from '#/components/Chip'
import Colors from '#/styles/Colors'

export type SanitaryProtocolStatus = {
  status: string
  text: string
}

interface TypeSanitaryProtocolStatusProps {
  value: SanitaryProtocolStatus
  sx?: SxProps<Theme>
}

export function TypeSanitaryProtocolStatus({ sx, value }: TypeSanitaryProtocolStatusProps) {
  if (isEmpty(value)) return '-'

  const { status, text } = value
  return <CowmedChip value={text} width={'unset'} style={Colors.status[status]} sx={sx} />
}
